import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить категорию" />
  </TopToolbar>
);

export const CategoryList: FC = () => (
  <List title="Список категорий" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Имя" />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
